import {SLASH, SLASH_ENCODED_URL_MARKER} from "@shared/models/shared.model";

export function getProductCodeUrlEncoded(code: string) {
  code = code.replace(SLASH, SLASH_ENCODED_URL_MARKER);
  return encodeURI(code);
}
